import { Injectable } from '@angular/core';
import { TableColumnType } from 'src/app/constants/table';
import { TableColumn, ToggleColumnProperty } from 'src/app/models/table';
import { TextType } from 'src/app/constants/text-type';

@Injectable()
export class TableService {

    public extractTableColumnNames(tableColumns: TableColumn[]): string[] {
        let l_Columns: string[] = [];

        tableColumns.forEach((tc: TableColumn) => {
            l_Columns.push(tc.propertyId);
        });

        return l_Columns;
    }

   /** isCustomColumnNameMatchValueName is for
     * When the header name is the property name, we need to ignore the period split.
     * Reason why we need the period split when the column name drills down to child datea.
     * IE member.memberBenefit.payroll.payrollTax
     */
    public findElementByColumnName(element: any, column: string, textType: TextType, isCustomColumnNameMatchValueName: boolean = false): any {
        let value: any = element;

        if (isCustomColumnNameMatchValueName) {
            value = value[column]
        } else {
            const splitProperties: string[] = column.split('.');
            splitProperties.forEach((sp: string) => {
                value = value[sp];
            });
        }

        if (textType) {
            switch (textType) {
                case TextType.currency:
                    value = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(value);
                    break;

                case TextType.percent:
                    parseInt(value);
                    value = `${value * 100}%`;
                    break;
            }
        }
        if (typeof value === 'string' && value.includes("Checkout completed on:")) {
            value = value.replace("Checkout completed on:", "");
        }

        return value;
    }

    public displayIconButton(element: any, tableColumn: TableColumn): boolean {
        let l_Display: boolean;

        if (!tableColumn.toggleProperties)
            return true;

        tableColumn.toggleProperties.forEach((tp: ToggleColumnProperty) => {
            if (!l_Display && element[tp.propertyId])
                l_Display = element[tp.propertyId].length > 0;
        });

        return l_Display;
    }

    public displayElement(tableColumn: TableColumn, type: TableColumnType, element: any): boolean {
        if (tableColumn.columnType != type)
            return false;

        if (tableColumn.hideElementByPropertyId) {
            if (!element[tableColumn.hideElementByPropertyId])
                return false;
        }

        return true;
    }
}